export const resize = (image, width, height) => image && image.replace(/(\.\w+)$/, `_${width}x${height || width}$1`);
